import { Injectable } from '@angular/core';
import { InlineAddConfig } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class StockCategoryAddConfigService {
  getStockCategoryConfig(): InlineAddConfig {
    return {
      modelType: 'stockcategory',
      title: 'Stock Category',
      apiEndpoint: 'api/stockcategories/create',
      hiddenData: {
        isActive: true,
      },
      fields: [ 
        {
          name: 'code',
          label: 'Stock Category Code',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 50,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter category name',
          size: 'half'
        },
        
      ],
      showMoreDetails: false,
      selectionConfig: {
        targetField: 'stockCategoryId',
        valueField: 'id',
        labelField: 'code'
      }
    };
  }
}
